var _dec, _dec2, _class, _class2, _temp;
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import { connectState } from '../../redux/connect';
import { Form } from '4finance-onion-form';
import { Map } from 'immutable';
import translate from '4finance-translate';
import injectStyles from '4finance-components';
import styles from './EnterNewPassword.jss';
import { Password, SubmitButton } from '../../fields';
var EnterNewPassword = (_dec = connectState({
  passwordProps: ['passwordRecover', 'fieldsProps', 'password']
}), _dec2 = injectStyles(styles), _dec(_class = translate(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EnterNewPassword, _React$PureComponent);
  function EnterNewPassword() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, EnterNewPassword);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(EnterNewPassword)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_onSubmit", function (fields) {
      var saveNewPassword = _this.props.saveNewPassword;
      saveNewPassword(fields.values.passwordInput);
    });
    return _this;
  }
  _createClass(EnterNewPassword, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        msg = _this$props.msg,
        passwordProps = _this$props.passwordProps,
        strongPassword = _this$props.strongPassword,
        customPasswordValidation = _this$props.customPasswordValidation;
      return React.createElement("div", {
        className: classes.container
      }, React.createElement(Form, {
        name: "enterNewPassword",
        onSubmit: this._onSubmit,
        resetOnMount: true
      }, React.createElement("div", {
        className: classes.formInnerWrapper
      }, React.createElement("h1", null, msg('enterNewPassword.title')), React.createElement("p", {
        className: classes.description
      }, msg('enterNewPassword.subtitle')), React.createElement("div", {
        className: classes.formControl
      }, React.createElement(Password, {
        name: "passwordInput",
        className: classes.password,
        fieldProps: passwordProps.toJS(),
        strongPassword: strongPassword,
        customPasswordValidation: customPasswordValidation,
        bordered: true
      })), React.createElement(SubmitButton, {
        type: "submit"
      }, msg('enterNewPassword.savePasswordButton')))));
    }
  }]);
  return EnterNewPassword;
}(React.PureComponent), _defineProperty(_class2, "styleRoot", 'EnterNewPassword'), _defineProperty(_class2, "defaultProps", {
  classes: {},
  msg: function msg() {
    return '';
  },
  passwordProps: Map()
}), _temp)) || _class) || _class) || _class);
export { EnterNewPassword as default };